<template>
  <template v-if="authStore.token">
    <RHeadline tag="h4">Signed in as</RHeadline>
    <RHeadline tag="h5">{{ authStore.email }}</RHeadline>
    <RTable>
      <template #head>
        <th>
          Key
        </th>
        <th>
          Value
        </th>
      </template>
      <template #main>
        <tbody>
          <tr>
            <td>
              <pre>token</pre>
            </td>
            <td>
              {{ authStore.token }}
            </td>
          </tr>
          <tr>
            <td>
              <pre>access_token</pre>
            </td>
            <td>
              {{ authStore.accessToken }}
            </td>
          </tr>
        </tbody>
      </template>
    </RTable>

  </template>
  <template v-else>
      <RButton @click="signIn()">Sign In</RButton>
  </template>
</template>

<script setup lang="ts">
import RHeadline from "~/components/shared/ui-lib/atoms/RHeadline/RHeadline.vue";
import RButton from "~/components/shared/ui-lib/atoms/RButton/RButton.vue";
import RTable from "~/components/shared/ui-lib/atoms/RTable/RTable.vue";

const authStore = useAuthStore();
const config = useRuntimeConfig();

function signIn(): void {
  window.location.href = `${config.public.strapiUrl}/api/connect/fusionauth`
}
</script>